<template>
  <section>
    <gs-header title="Quản lý phiếu chi">
      <el-button type="primary" size="small" icon="el-icon-plus">
        <router-link :to="{ name: 'create-invoice' }" class="text-remove-decoration text-white">Thêm mới</router-link>
      </el-button>
      <el-button size="small" icon="el-icon-s-data">
        <router-link :to="{ name: 'invoice-report' }" class="text-remove-decoration text-black">Báo cáo</router-link>
      </el-button>
      <el-button size="small" @click.prevent="exportExcel" icon="el-icon-download">Xuất excel</el-button>
      <el-button size="small" @click.prevent="dialogExportZh = true" icon="el-icon-download">Xuất bảng kê</el-button>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="invoiceTable" :table-name="invoiceTable" data-source="invoices"
        :data-params="filters" :cache-data="false" :data-sorts="sorts" :data-sorted="sorted" @remove-filter="removeFilter"
        @filter-change="gsFilterChange">
        <!-- :data-sorted="sorted"
        :data-sorts="sorts" -->
        <section slot="filters" style="margin-bottom: 24px;">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :lg="6">
              <div class="block">
                <el-date-picker class="width-100" v-model="filterDateRange" type="daterange" range-separator=" / "
                  @input="updateFilters" format="dd-MM-yyyy" start-placeholder="Từ ngày" end-placeholder="Đến ngày">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="6">
              <el-select class="display-block" v-model="filters.bank_id" filterable placeholder="Ngân hàng"
                @change="filter">
                <el-option v-for="bank in banks" :key="bank.id" :label="bank.name + ' (' + bank.short_name + ')'"
                  :value="bank.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="6">
              <el-select class="display-block" v-model="filters.kind" filterable clearable placeholder="Kiểu đối soát"
                @change="filter">
                <el-option v-for="(kindName, kindKey) in crossChecksHelpers.kinds" :key="kindKey" :label="kindName"
                  :value="kindKey">
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="6">
              <select-client v-model="filters.client_id" @input="filter" placeholder="Gõ để tìm kiếm khách hàng" />
            </el-col>
          </el-row>
          <el-row :gutter="10" class="margin-top">
            <el-col :xs="24" :sm="12" :lg="6">
              Tiền thanh toán:
              <el-radio-group class="status-listting margin-lg-right" v-model="filters.is_negative" @change="filter"
                :fill="filters.is_negative ? '#32CD32' : '#db2828'">
                <el-radio-button :label="0"><span
                    :class="{ 'text-red': filters.is_negative != 0 }">Âm</span></el-radio-button>
                <el-radio-button :label="1"><span
                    :class="{ 'text-green': filters.is_negative != 1 }">Dương</span></el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="margin-top">
            <el-col :span="24">
              <a class="cursor-pointer padding-all" @click.prevent="setFilterStatus(status.key, status.value)"
                v-for="(status, index) in statuses" :key="index"
                :class="[{ 'active-status': status.value === filters[status.key] }, status.class]">{{ status.title }}</a>
            </el-col>
          </el-row>
        </section>
        <span slot="inline-filters">
          <el-dropdown v-show="filters.is_payment < 0" v-if="selectedRows.length > 0" class="margin-right" trigger="click"
            @command="handleActions">
            <el-button type="primary" size="small">
              Hành động <i class="el-icon-caret-bottom el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="filters.is_confirm == 0 ? false : true" command="confirmAll">Duyệt tất
                cả</el-dropdown-item>
              <el-dropdown-item :disabled="filters.is_confirm == 0 ? false : true" command="deleteAll">Xóa tất
                cả</el-dropdown-item>
              <el-dropdown-item :disabled="filters.is_confirm == 1 ? false : true" command="paymentAll">Thanh toán tất
                cả</el-dropdown-item>
              <el-dropdown-item :disabled="filters.is_confirm == 1 ? false : true" command="exportAll">Xuất
                Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          Tổng tiền cần chuyển: <span class="text-red">{{ totalMoneyNeedConfirm | vnd }}</span> &nbsp;&nbsp;-&nbsp;&nbsp;
          Tổng tiền: <span class="text-red">{{ totalMoney | vnd }}</span>
        </span>
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" width="55">
            </el-table-column>
            <el-table-column label="#" align="center" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[invoiceTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[invoiceTable].current_page - 1) * dataPaginations[invoiceTable].per_page) }}</small>
              </template>
            </el-table-column>

            <el-table-column label="Phiếu chi" width="150">
              <template slot-scope="scope">
                <p><span class="shipment-code-display click-copy">{{ scope.row.id }}</span></p>
                <p>
                  <el-tooltip placement="top" content="Ngày tạo" class="display-inline">
                    <span>{{ scope.row.created_at }}</span>
                  </el-tooltip>
                </p>
                <p v-if="scope.row.cross_check">
                  <el-tooltip placement="top" content="Mã đối soát" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.cross_check.data.id }}</span>
                  </el-tooltip>
                </p>
                <p><el-tag size="small" :type="kindStatus(scope.row.kind)">{{ scope.row.kind_txt }}</el-tag></p>
              </template>
            </el-table-column>

            <el-table-column label="Shop">
              <template slot-scope="scope">
                <div v-if="scope.row.client">
                  <p><i class="fa fa-user"></i>&nbsp;{{ scope.row.client.data.name }}</p>
                  <p class="click-copy"><i class="fa fa-phone"></i>&nbsp;{{ scope.row.client.data.phone }}</p>
                  <p :class="{ 'text-red': scope.row.client.data.debit_amount < 0 }"><i class="fa fa-money"></i>&nbsp;{{
                    scope.row.client.data.debit_amount | vnd }}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Tài khoản NH">
              <template slot-scope="scope">
                <div v-if="!getBankInfo(scope.row.bank_info).length">
                  {{ scope.row.bank_info }}
                </div>
                <div class="margin-bottom" v-for="(item, index) in getBankInfo(scope.row.bank_info)" :key="index">
                  <span class="click-copy">{{ item.value }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Tổng tiền trả shop">
              <template slot-scope="scope">
                <p>Tổng phí: <span class="text-red">{{ scope.row.debt | vnd }}</span></p>
                <p v-if="scope.row.money_return > 0">Truy thu: <span class="text-red">{{ scope.row.money_return | vnd
                }}</span></p>
                <p>Thực trả: <span class="text-red click-copy">{{ scope.row.real_amount | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết" class="display-inline">
                    <router-link class="text-blue padding-all display-inline-block"
                      :to="{ name: 'detail-invoice', params: { id: scope.row.id } }"><i class="fa fa-search"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.confirmer_id">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-invoice', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.confirmer_id">
                    <a @click.prevent="deleteInvoice(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xác nhận" class="display-inline" v-if="!scope.row.confirmer_id">
                    <a @click.prevent="confirmInvoice(scope.row)"
                      class="text-green padding-all display-inline-block cursor-pointer"><i class="fa fa-check"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Thanh toán" class="display-inline" v-if="scope.row.can_payment">
                    <a @click.prevent="payInvoice(scope.row)"
                      class="text-violet padding-all display-inline-block cursor-pointer"><i class="fa fa-money"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Gửi lại email" class="display-inline" v-if="scope.row.payer_id">
                    <a @click.prevent="sendEmail(scope.row)"
                      class="text-violet padding-all display-inline-block cursor-pointer"><i
                        class="fa fa-envelope-o"></i></a>
                  </el-tooltip>
                  <!-- <el-tooltip placement="top" content="Truy thu" class="display-inline" v-if="scope.row.payer_id && !scope.row.returner_id">
                     <a @click.prevent="returnInvoice(scope.row)" class="text-purple padding-all display-inline-block cursor-pointer"><i class="fa fa-usd"></i></a>
                  </el-tooltip> -->
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
    <el-dialog title="Xuất bảng kê" :visible.sync="dialogExportZh">
      <el-form :model="paramsExportZh" :rules="rules" label-position="left" ref="paramsExportZhRef" label-width="200px"
        class="demo-ruleForm" @submit.prevent.native="validateBeforeSubmit">
        <el-radio-group v-model="selectedCrossCheckMode" size="small" class="el-form-item display-block">
          <el-radio-button v-for="item in crossCheckList" :key="item.value" :label="item.value">{{ item.name }}</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="selectedDateMode" size="small" class="el-form-item display-block">
          <el-radio-button :label="1">Theo ngày</el-radio-button>
          <el-radio-button :label="2">Theo khoảng thời gian</el-radio-button>
        </el-radio-group>
        <el-form-item v-show="selectedDateMode === 1" label="Ngày tạo" prop="createdAt">
          <el-date-picker class="width-100" v-model="paramsExportZh.createdAt" type="date" format="dd-MM-yyyy"
            value-format="yyyy-MM-dd" placeholder="Chọn ngày">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-show="selectedDateMode === 2" label="Ngày tạo" prop="createdAt">
          <el-date-picker class="width-100" v-model="paramsExportZh.createdAtRange" type="daterange" format="dd-MM-yyyy"
            value-format="yyyy-MM-dd" range-separator=" / " start-placeholder="Từ ngày" end-placeholder="Đến ngày">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Chọn hãng vận chuyển" prop="carrierId">
          <el-select class="width-100" :value="paramsExportZh.carrierId.map(item => JSON.stringify(item))"
            @change="handleChangeCarrier" multiple filterable placeholder="Chọn cột tương ứng">
            <el-option v-for="item in carrierZhs" :key="item.id" :label="item.name" :value="JSON.stringify(item)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="getCrossCheckKindCod || getCrossCheckKindcompareFee" label="Trạng thái">
          <el-radio-group v-model="paramsExportZh.status" size="small">
            <el-radio-button label="success">Hoàn thành</el-radio-button>
            <el-radio-button label="unsuccess">Chưa hoàn thành</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogExportZh = false">Hủy bỏ</el-button>
        <el-button type="primary" :loading="submitting" @click="validateBeforeSubmit">Tải xuống</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import ls from 'local-storage'
import { debounce, keys, forEach, map } from 'lodash'
import { formatDate } from 'src/helpers'
import { mapGetters, mapActions } from 'vuex'
import SelectClient from 'src/components/client/SelectClient'
import {
  deleteInvoice,
  confirmInvoice,
  paymentInvoice,
  exportExcel,
  returnInvoice,
  resendEmail,
  getTotalDebt,
  getTotalDebtByFilter,
  confirmAllInvoice,
  paymentAllInvoice,
  exportAllInvoice,
  exportCodListing,
  exportFeeListing,
  exportCompareFeeListing
} from 'src/api/invoice'
import moment from 'moment'
import { CROSS_CHECK_TYPE } from "src/constants"

export default {
  name: 'Invoice',
  components: {
    SelectClient,
  },
  data() {
    return {
      invoiceTable: 'invoices',
      totalMoneyNeedConfirm: 0,
      totalMoney: 0,
      filterDateRange: '',
      selectedRows: [],
      filters: {
        sort: 'id:-1',
        include: 'creator,client,confirmer,payer,returner,cross_check',
        client_id: '',
        is_confirm: 0,
        is_payment: -1,
        is_return: -1,
        start_date: '',
        end_date: '',
        bank_id: '',
        kind: '',
        is_negative: ''
      },
      sorted: {
        id: -1,
        real_amount: ''
      },
      sorts: [
        { key: 'id', name: 'Ngày tạo' },
        { key: 'real_amount', name: 'Tổng tiền trả shop' }
      ],
      statuses: [
        { key: 'is_confirm', value: 0, title: 'Chưa xác nhận', class: 'text-red' },
        { key: 'is_confirm', value: 1, title: 'Đã xác nhận', class: 'text-orange' },
        { key: 'is_payment', value: 1, title: 'Đã thanh toán', class: 'text-green' },
        { key: 'is_return', value: 1, title: 'Đã truy thu', class: 'text-violet' },
        { key: 'all', value: 1, title: 'Tất cả', class: 'text-blue' }
      ],
      showData: false,
      dialogExportZh: false,
      paramsExportZh: {
        createdAt: undefined,
        createdAtRange: undefined,
        carrierId: [],
        status: 'success'
      },
      submitting: false,
      rules: {
        createdAt: [
          { required: true, message: 'Chọn ngày là bắt buộc', trigger: 'change' },
        ],
        createdAtRange: [
          { required: true, message: 'Chọn ngày là bắt buộc', trigger: 'change' },
        ],
        carrierId: [
          { required: true, message: 'Chọn hãng vận chuyển là bắt buộc', trigger: 'change' }
        ]
      },
      selectedDateMode: 1,
      selectedCrossCheckMode: 1,
    }
  },
  computed: {
    ...mapGetters('invoice', ['invoice']),
    ...mapGetters('bank', ['banks']),
    ...mapGetters('carrier', ['carrierZhs']),
    ...mapGetters('compare', ['crossChecksHelpers']),
    getCrossCheckKindCod() {
      return this.selectedCrossCheckMode == CROSS_CHECK_TYPE.COD
    },
    getCrossCheckKindcompareFee() {
      return this.selectedCrossCheckMode == CROSS_CHECK_TYPE.COMPARE_FEE
    },
  },
  methods: {
    ...mapActions('invoice', ['setInvoice']),
    ...mapActions('bank', ['getAllBanks']),
    ...mapActions('carrier', ['getAllCarrierZhCod']),
    ...mapActions('compare', ['getCrossChecksHeppers']),
    validateBeforeSubmit() {
      this.submitting = true
      this.$refs.paramsExportZhRef.validate((valid) => {
        if (valid) {
          const data = {
            createdAt: this.selectedDateMode === 1 ? this.paramsExportZh.createdAt : this.paramsExportZh.createdAtRange,
            carrierId: this.paramsExportZh.carrierId.map(carrier => carrier.id).join(','),
            status: this.getCrossCheckKindCod || this.getCrossCheckKindcompareFee ? this.paramsExportZh.status : undefined
          }
          if (typeof data.createdAt === 'string') {
            const formattedDate = this.addition1Day(data.createdAt)
            data.createdAt = `${data.createdAt},${formattedDate}`
          } else {
            const formattedDate = this.addition1Day(data.createdAt[1])
            data.createdAt = `${data.createdAt[0]},${formattedDate}`
          }
          const carrierName = this.paramsExportZh.carrierId.map(carrier => carrier.short_name).join('-').toUpperCase()
          if (this.getCrossCheckKindCod) {
            exportCodListing(data).then(res => {
              switch (res.status) {
                case 200:
                  const createdAt = data.createdAt.split(',')
                  const nameDate = this.selectedDateMode === 1 ? moment(createdAt[0]).format('DD-MM-YYYY') : `${moment(createdAt[0]).format('DD-MM-YYYY')} - ${moment(this.paramsExportZh.createdAtRange[1]).format('DD-MM-YYYY')}`
                  this.saveBlobToFile(res.data, nameDate, carrierName)
                  this.submitting = false
                  break
                case 400:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error',
                  })
                  break
                default:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: res.data.message || 'Có lỗi xảy ra',
                    type: 'error',
                  })
              }
            })
              .catch(err => {
                if (err.message.includes('status code 400')) {
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error',
                  })
                } else {
                  this.$store.dispatch('showNotify', {
                    title: err.message,
                    type: 'error',
                  })
                }
                this.submitting = false
              })
          } else if (this.getCrossCheckKindcompareFee) {
            exportCompareFeeListing(data).then(res => {
              switch (res.status) {
                case 200:
                  const createdAt = data.createdAt.split(',')
                  const nameDate = this.selectedDateMode === 1 ? moment(createdAt[0]).format('DD-MM-YYYY') : `${moment(createdAt[0]).format('DD-MM-YYYY')} - ${moment(this.paramsExportZh.createdAtRange[1]).format('DD-MM-YYYY')}`
                  this.saveBlobToFile(res.data, nameDate, carrierName)
                  this.submitting = false
                  break
                case 400:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error',
                  })
                  break
                default:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: res.data.message || 'Có lỗi xảy ra',
                    type: 'error',
                  })
              }
            })
              .catch(err => {
                if (err.message.includes('status code 400')) {
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error',
                  })
                } else {
                  this.$store.dispatch('showNotify', {
                    title: err.message,
                    type: 'error',
                  })
                }
                this.submitting = false
              })
          } else {
            exportFeeListing(data).then(res => {
              switch (res.status) {
                case 200:
                  this.submitting = false
                  const createdAt = data.createdAt.split(',')
                  const nameDate = this.selectedDateMode === 1 ? moment(createdAt[0]).format('DD-MM-YYYY') : `${moment(createdAt[0]).format('DD-MM-YYYY')} - ${moment(this.paramsExportZh.createdAtRange[1]).format('DD-MM-YYYY')}`
                  this.saveBlobToFile(res.data, nameDate, carrierName)
                  break
                case 400:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error',
                  })
                  break
                default:
                  this.submitting = false
                  this.$store.dispatch('showNotify', {
                    title: res.data.message || 'Có lỗi xảy ra',
                    type: 'error',
                  })
              }
            })
              .catch(err => {
                if (err.message.includes('status code 400')) {
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng thử lại sau ít phút',
                    type: 'error',
                  })
                } else {
                  this.$store.dispatch('showNotify', {
                    title: err.message,
                    type: 'error',
                  })
                }
                this.submitting = false
              })
          }
        } else {
          this.submitting = false
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning',
          })
        }
      })
    },
    saveBlobToFile(blob, date, shortName) {
      // Tạo URL từ Blob
      const url = URL.createObjectURL(blob);

      // Tạo một thẻ <a> để kích hoạt việc tải file
      const link = document.createElement('a');
      link.href = url;
      link.download = `Bảng kê ${this.setNameExportList(this.selectedCrossCheckMode)} ${date} ${shortName}`;  // Tên file sẽ tải xuống

      // Kích hoạt tải file
      link.click();

      // Giải phóng URL sau khi tải xong
      URL.revokeObjectURL(url);
    },
    setNameExportList(val) {
      return this.crossCheckList.find(item => item.value === val).name
    },
    addition1Day(date) {
      return moment(date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
    },
    updateFilters(data) {
      const startDate = data ? formatDate(data[0]) : null
      const endDate = data ? formatDate(data[1]) : null

      this.filters.start_date = startDate
      this.filters.end_date = endDate
      this.filter()
    },
    setFilterStatus(key, value) {
      this.filters['is_confirm'] = -1
      this.filters['is_payment'] = -1
      this.filters['is_return'] = -1
      this.filters['all'] = ''
      this.filters[key] = value

      this.filter()
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.invoiceTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.getTotalDebtInvoice()
        this.getTotalDebtInvoiceByFilter()
        this.reloadGsTable(this.invoiceTable)
      }
      this.$router.push({ query: this.filters })
    }, 300),
    gsFilterChange(e) {
      this.getTotalDebtInvoice()
      this.getTotalDebtInvoiceByFilter()
    },
    removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'id:-1',
        include: 'creator,client,confirmer,payer,returner,cross_check',
        client_id: '',
        is_confirm: 0,
        is_payment: -1,
        is_return: -1,
        start_date: '',
        end_date: '',
        bank_id: '',
        kind: '',
        is_negative: ''
      }) || this.filters.is_confirm !== 0 || this.filters.is_confirm !== -1) {
        this.reloadGsTable(this.invoiceTable)
      }
      this.filterDateRange = ''
      this.filters = {
        sort: 'id:-1',
        include: 'creator,client,confirmer,payer,cross_check',
        client_id: '',
        is_confirm: 0,
        is_payment: -1,
        start_date: '',
        end_date: '',
        bank_id: '',
        kind: '',
        is_negative: ''
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    deleteInvoice(invoice) {
      this.setInvoice(invoice)
      this.$confirm(`Bạn chắc chắn muốn xóa phiếu chi ${this.invoice.id}`, 'Xóa phiếu chi', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delInvoice()
      }).catch(() => {

      })
    },
    confirmInvoice(invoice) {
      this.setInvoice(invoice)
      this.$confirm(`Bạn chắc chắn muốn xác nhận phiếu chi ${this.invoice.id}`, 'Xác nhận phiếu chi', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.confInvoice()
      }).catch(() => {

      })
    },
    payInvoice(invoice) {
      this.setInvoice(invoice)
      this.$confirm(`Bạn chắc chắn muốn thanh toán phiếu chi ${this.invoice.id}`, 'Thanh toán phiếu chi', {
        confirmButtonText: 'Thanh toán',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.pInvoice()
      }).catch(() => {

      })
    },
    returnInvoice(invoice) {
      this.setInvoice(invoice)
      this.$confirm(`Bạn chắc chắn muốn truy thu phiếu chi ${this.invoice.id}`, 'Truy thu phiếu chi', {
        confirmButtonText: 'Truy thu',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.rInvoice()
      }).catch(() => {

      })
    },
    delInvoice() {
      deleteInvoice(this.invoice.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa phiếu chi thành công'
          })
          this.reloadGsTable(this.invoiceTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Xóa phiếu chi thất bại'
          })
        }
      })
    },
    confInvoice() {
      confirmInvoice(this.invoice.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xác nhận phiếu chi thành công'
          })
          this.reloadGsTable(this.invoiceTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Xác nhận phiếu chi thất bại'
          })
        }
      })
    },
    pInvoice() {
      paymentInvoice(this.invoice.id).then(response => {
        switch (response.code) {
          case 200:
            this.$message({
              type: 'success',
              message: 'Thanh toán phiếu chi thành công'
            })
            this.reloadGsTable(this.invoiceTable)
            break
          case 422:
            this.$message({
              type: 'error',
              message: response.data.errors
            })
            break
          default:
            this.$message({
              type: 'error',
              message: 'Thanh toán phiếu chi thất bại'
            })
        }
      })
    },
    rInvoice() {
      returnInvoice(this.invoice.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Truy thu phiếu chi thành công'
          })
          this.reloadGsTable(this.invoiceTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Truy thu phiếu chi thất bại'
          })
        }
      })
    },
    exportExcel() {
      this.toggleLoadding(true)
      exportExcel(this.filters).then(response => {
        this.toggleLoadding(false)
        window.location.href = response.full
      })
    },
    sendEmail(invoice) {
      this.toggleLoadding(true)
      resendEmail(invoice.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Gửi email thành công'
          })
          this.toggleLoadding(false)
        } else {
          this.$message({
            type: 'error',
            message: 'Gửi email thất bại'
          })
          this.toggleLoadding(false)
        }
      })
    },
    getTotalDebtInvoice() {
      getTotalDebt(this.filters).then(response => {
        if (response.code === 200) {
          this.totalMoneyNeedConfirm = response.data ? response.data.total : 0
        } else {
          this.$message({
            type: 'error',
            message: 'Có lỗi xảy ra khi lấy thông tin tổng tiền.'
          })
        }
      })
    },
    getTotalDebtInvoiceByFilter() {
      getTotalDebtByFilter(this.filters).then(response => {
        if (response.code === 200) {
          this.totalMoney = response.data ? response.data.total : 0
        } else {
          this.$message({
            type: 'error',
            message: 'Có lỗi xảy ra khi lấy thông tin tổng tiền.'
          })
        }
      })
    },
    getBankInfo(value) {
      let data = []
      if (!value) return data
      let strings = value.split('|')
      if (strings.length === 1) {
        strings = value.split('.')
      }
      if (strings.length > 2) {
        data = [
          { text: 'Tên tài khoản', value: strings[1].trim() },
          { text: 'Số tài khoản', value: strings[2].trim() },
          { text: 'Ngân hàng', value: strings[0].trim() }
        ]
      }
      return data
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows
    },
    handleActions(cmd) {
      let invoiceIds = map(this.selectedRows, 'id')

      // Xác nhận phiếu chi đã chọn
      if (cmd === 'confirmAll') {
        this.$confirm(`Bạn chắc chắn muốn xác nhận phiếu chi đã chọn?`, 'Xác nhận phiếu chi', {
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Không',
          type: 'warning'
        }).then(() => {
          confirmAllInvoice(invoiceIds).then(res => {
            if (res.count > 0) {
              this.$message({
                type: 'success',
                message: `Xác nhận ${res.count} phiếu chi thành công.`
              })
              this.reloadGsTable(this.invoiceTable)
            } else {
              this.$message({
                type: 'error',
                message: `Xác nhận phiếu chi thất bại.`
              })
            }
          })
        }).catch(() => { })
      }

      // Xóa phiếu chi đã chọn
      if (cmd === 'deleteAll') {
        this.$message({
          type: 'error',
          message: `Tính năng đang tạm thời bị vô hiệu hóa bởi Admin.`
        })
      }

      // Export excel
      if (cmd === 'exportAll') {
        exportAllInvoice(invoiceIds).then(res => {
          window.location.href = res.full
        })
      }

      // Thanh toán phiếu chi
      if (cmd === 'paymentAll') {
        this.$confirm(`Bạn chắc chắn muốn Thanh toán phiếu chi đã chọn?`, 'Thanh toán phiếu chi', {
          confirmButtonText: 'Thanh toán',
          cancelButtonText: 'Không',
          type: 'warning'
        }).then(() => {
          paymentAllInvoice(invoiceIds).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: `Thanh toán phiếu chi thành công.`
              })
              this.reloadGsTable(this.invoiceTable)
            } else {
              this.$message({
                type: 'error',
                message: `Thanh toán phiếu chi thất bại.`
              })
            }
          })
        }).catch(() => { })
      }
    },
    handleChangeCarrier(val) {
      this.paramsExportZh.carrierId = val.map(item => JSON.parse(item))
    },
    kindStatus(kind) {
      switch (kind) {
        case 1:
          return 'success'
        case 2:
          return 'danger'
        default:
          return 'info'
      }
    }
  },
  watch: {
    carrierZhs: {
      handler: function (val) {
        this.paramsExportZh.carrierId = [val[0]]
      },
      immediate: true
    },
    '$route.query': {
      handler(newQuery) {
        this.filters = { ...this.filters, ...newQuery }
        if (this.filters.start_date && this.filters.end_date) {
          this.filterDateRange = [
            this.filters.start_date,
            this.filters.end_date,
          ]
        }
        ['bank_id', 'is_confirm', 'is_payment', 'is_return', 'all', 'is_negative'].forEach((key) => {
          if (this.filters[key]) {
            this.filters[key] = Number(this.filters[key])
          }
        })
      },
      deep: true, // Theo dõi sâu các thay đổi bên trong đối tượng query (nếu cần)
      immediate: true, // Gọi handler ngay khi component được tạo (lần đầu tiên)
    },
  },
  mounted() {
    this.clickToCopy()
    const dateNow = moment().format('YYYY-MM-DD')
    const formattedDate = this.addition1Day(dateNow)
    this.paramsExportZh.createdAt = dateNow
    this.paramsExportZh.createdAtRange = [dateNow, moment(formattedDate).format('YYYY-MM-DD')]
    if (ls.get('filters') && ls.get('filters')[this.invoiceTable]) {
      this.filters = ls.get('filters')[this.invoiceTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    setTimeout(() => {
      this.showData = true
    }, 200)
    this.listenReloadGsTable()
    if (Object.keys(this.getSorted(this.invoiceTable)).length) {
      this.sorted = this.getSorted(this.invoiceTable)
    }
    this.getTotalDebtInvoice()
    this.getTotalDebtInvoiceByFilter()
    if (!this.banks.length) {
      this.getAllBanks()
    }
    if (!this.carrierZhs.length) {
      this.getAllCarrierZhCod()
    }
    if (!Object.keys(this.crossChecksHelpers).length) {
      this.getCrossChecksHeppers()
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['invoices']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.active-status {
  font-weight: bold;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// Invoice.vue?57205608